import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/sign-in',
            name: 'signin',
            component: () => import('./views/Signin.vue')
        },
        {
            path: '/events',
            name: 'evvents',
            component: () => import('./views/Events.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./views/Users.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/packages',
            name: 'packages',
            component: () => import('./views/Packages.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/services',
            name: 'services',
            component: () => import('./views/Services.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/payments',
            name: 'payments',
            component: () => import('./views/Payments.vue'),
            meta: {
                authRequired: true
            }
        },

        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.idToken) {
            next({
                path: '/sign-in'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
